<template>
  <div class="company-area no-top">
    <a
      v-if="companyName"
      class="company-name"
    >
      {{ companyName }}
    </a>
    <h1 class="company-title">
      {{ title }}
      <job-employment-status-sp :employment-status="employmentStatus" />
    </h1>
    <div class="company-day">
      <p class="icon">
        <img
          :src="`${userOfferImageUrlForSp}/icon_company_new.png`"
          alt="NEW"
          class="new-icon"
        >
        <img
          v-if="isSimple && !isOriginalEntryForm"
          :src="`${userOfferImageUrlForSp}/icon_company_simple.png`"
          alt="シンプル応募"
          class="simple-interview-icon"
        >
      </p>
      <p class="limit">
        掲載期間 yyyy/mm/dd〜yyyy/mm/dd
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import JobEmploymentStatusSp from '@/components/molecules/JobEmploymentStatusSp'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  components: {
    JobEmploymentStatusSp
  },
  mixins: [jobPreviewCommon],
  props: {
    companyName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    isSimple: {
      type: Boolean,
      required: true
    },
    isOriginalEntryForm: {
      type: Boolean,
      required: true
    },
    employmentStatus: {
      type: Array,
      default: () => []
    }
  }
}
</script>
